/**
 * @author Hiroki Moto
 * @description https://xd.adobe.com/view/9088a00e-a17f-43e7-5a33-cfa5e833aac8-e6b9/screen/e264e544-0557-40d2-b820-21660b2afa70/Buttons
 */

import React from 'react';
import PropTypes from 'prop-types';
import BootstrapButton from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import SplitButton from 'react-bootstrap/SplitButton';
import cx from 'classnames';
import { toast } from 'react-toastify';

const Button = ({
    className = '',
    type = 'high',
    name = '',
    options = [],
    children,
    disabled = false,
    busy = false,
    size = 'small',
    ringSize = 18,
    direction = 'down',
    alert = '',
    onClick = () => {},
}) => {
    const handleClick = (e = '') => {
        if (disabled && !alert) {
            return;
        } else if (disabled && !!alert) {
            toast.warn(alert, { position: toast.POSITION.TOP_RIGHT });
        } else {
            onClick(e);
        }
    };

    if (options.length === 0) {
        return (
            <BootstrapButton className={cx('core-button', type, `size-${size}`, className, { disabled })} disabled={disabled && !alert} onClick={handleClick}>
                {busy ? (
                    <div className={`lds-dual-ring ring-${ringSize}`} />
                ) : (
                    children || <div className={cx('truncate-one', type === 'high' || type === 'medium' ? 'text-400' : 'text-300')}>{name}</div>
                )}
            </BootstrapButton>
        );
    }

    return (
        <SplitButton
            className={cx('core-button split p-0', type, `size-${size}`, className, { disabled })}
            id={`cdb${name}`}
            align="end"
            drop={direction}
            title={
                busy ? (
                    <div className={`lds-dual-ring ring-${ringSize}`} />
                ) : (
                    children || <div className={cx('truncate-one', type === 'high' || type === 'medium' ? 'text-400' : 'text-300')}>{name}</div>
                )
            }
            onClick={() => handleClick('')}
        >
            {options.map((item, index) => (
                <Dropdown.Item key={`cdb${index}`} eventKey={index} onClick={() => handleClick(item)}>
                    <span className="dsl-b16 text-nowrap">{item}</span>
                </Dropdown.Item>
            ))}
        </SplitButton>
    );
};

Button.propTypes = {
    className: PropTypes.string,
    type: PropTypes.oneOf(['high', 'medium', 'low', 'link']),
    size: PropTypes.oneOf(['small', 'medium', 'big']),
    name: PropTypes.string,
    options: PropTypes.array,
    busy: PropTypes.bool,
    disabled: PropTypes.bool,
    /**
     * If button is disabled and it does have alert message, when clicking the button,
     * button will show a toast message with alert message.
     */
    alert: PropTypes.string,
    ringSize: PropTypes.number,
    direction: PropTypes.oneOf(['up', 'down', 'left', 'right']),
    onClick: PropTypes.func,
};

export default Button;
